module.exports = __webpack_public_path__ + "img/new-timer-icon.89ea9b7a.svg";